import React from 'react';
import { get } from 'lodash';
import Table from '../../../core/form/Table';
import PropTypes from 'prop-types';

const ImportCsvDialogResultScene = (props) => (
  <div>
    <span style={{ marginBottom: '15px', display: 'block' }}>
      {props.totalRows - props.errors.length} of {props.totalRows}{' '}
      <b>{get(props.values, 'locale', 'selected locale')}</b> values updated
    </span>
    <Table
      showTableCount={false}
      locale={{
        emptyText: 'No errors found',
      }}
      columns={[
        {
          label: 'Type',
          path: 'item.type',
        },
        {
          label: 'Key',
          path: 'item.key',
        },
        {
          label: 'Line',
          path: 'row',
        },
        {
          label: 'Error',
          path: 'error',
        },
      ]}
      rows={get(props.values, 'importResult.errors')}
    />
  </div>
);

ImportCsvDialogResultScene.propTypes = {
  values: PropTypes.object,
  errors: PropTypes.array,
  totalRows: PropTypes.number,
};

ImportCsvDialogResultScene.defaultProps = {
  errors: null,
  totalRows: 0,
};

export default ImportCsvDialogResultScene;
